module.exports = __webpack_public_path__ + "img/qr-code.39bb3bae.jpg";